<template>
  <aside class="h-full w-64 bg-white shadow-md flex flex-col">
    <nav class="py-6 px-4 overflow-y-auto flex-1">
      <ul class="space-y-2">
        <router-link
          to="/contentManagement/assessments"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/assessments') }"
        >
          <i class="pi pi-file mr-3"></i>
          <span>Assessment Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/templates"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/templates') }"
        >
          <i class="pi pi-bell mr-3"></i>
          <span>Notification Templates</span>
        </router-link>

        <router-link
          to="/contentManagement/dimensions"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/dimensions') }"
        >
          <i class="pi pi-compass mr-3"></i>
          <span>Dimensions Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/dev-tips"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/dev-tips') }"
        >
          <i class="pi pi-lightbulb mr-3"></i>
          <span>DevTips Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/scheduler"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/scheduler') }"
        >
          <i class="pi pi-clock mr-3"></i>
          <span>Scheduler Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/level-system"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/level-system') }"
        >
          <i class="pi pi-star mr-3"></i>
          <span>Level System Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/travel-buddy"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/travel-buddy') }"
        >
          <i class="pi pi-map mr-3"></i>
          <span>Travel Buddy Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/enums"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/enums') }"
        >
          <i class="pi pi-list mr-3"></i>
          <span>Enum Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/config"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/config') }"
        >
          <i class="pi pi-cog mr-3"></i>
          <span>Config Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/content"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/content') }"
        >
          <i class="pi pi-book mr-3"></i>
          <span>Content Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/features"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/features') }"
        >
          <i class="pi pi-sliders-h mr-3"></i>
          <span>Features Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/users"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/users') }"
        >
          <i class="pi pi-users mr-3"></i>
          <span>Users Manager</span>
        </router-link>

        <router-link
          to="/contentManagement/timeline"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/timeline') }"
        >
          <i class="pi pi-history mr-3"></i>
          <span>Timeline</span>
        </router-link>

        <router-link
          to="/contentManagement/user-assessments"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/user-assessments') }"
        >
          <i class="pi pi-chart-bar mr-3"></i>
          <span>User Assessments</span>
        </router-link>

        <router-link
          to="/contentManagement/external-evaluation"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/external-evaluation') }"
        >
          <i class="pi pi-users mr-3"></i>
          <span>External Evaluation</span>
        </router-link>

        <router-link
          to="/contentManagement/kss-series"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/kss-series') }"
        >
          <i class="pi pi-comments mr-3"></i>
          <span>KSS Series</span>
        </router-link>

        <router-link
          to="/enums"
          class="flex items-center p-3 text-gray-400 rounded-lg cursor-not-allowed"
          :class="{ 'bg-gray-100': isActive('/enums') }"
          @click.prevent
        >
          <i class="pi pi-list-check mr-3"></i>
          <span>Tasks Manager</span>
        </router-link>

        <!-- Divider -->
        <hr class="my-4 border-gray-200" />

        <!-- Developer Tools -->
        <router-link
          to="/contentManagement/developer"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/contentManagement/developer') }"
        >
          <i class="pi pi-code mr-3"></i>
          <span>Developer</span>
        </router-link>

        <!-- Data Import/Export - Only shown in single-tenant mode -->
        <router-link
          v-if="!isMultiTenant"
          to="/contentManagement/data-transfer"
          class="flex items-center p-3 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          :class="{ 'bg-pink-100 text-pink-600': isActive('/data-transfer') }"
        >
          <i class="pi pi-sync mr-3"></i>
          <span>Data Import/Export</span>
        </router-link>
      </ul>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'SideBar',
  data() {
    return {
      userInitials: 'AU',
    };
  },
  computed: {
    isMultiTenant() {
      return localStorage.getItem('multiTenantEnabled') === 'true';
    },
  },
  methods: {
    isActive(path) {
      return this.$route.path.endsWith(path);
    },
  },
};
</script>
